import styled from "styled-components";

export const TokenField = styled.div`
    @keyframes blink {
        0% {
            border-color: #ededed;
        }
        100% {
            border-color: #b94a48;
        }
    }

    .tokenfield {
        height: auto;
        min-height: 34px;
        padding-bottom: 0;
        padding-left: 6px;
    }
    .tokenfield.focus {
        border-color: #66afe9;
        outline: 0;
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6);
    }
    .tokenfield .token {
        box-sizing: border-box;
        border-radius: 3px;
        display: inline-block;
        border: 1px solid #d9d9d9;
        background-color: #ededed;
        white-space: nowrap;
        margin: -1px 5px 5px 0;
        height: 22px;
        vertical-align: top;
        cursor: default;
    }
    .tokenfield .token:hover {
        border-color: #b9b9b9;
    }
    .tokenfield .token.active {
        border-color: #52a8ec;
        border-color: rgba(82, 168, 236, 0.8);
    }
    .tokenfield .token.duplicate {
        border-color: #ebccd1;
        animation-name: blink;
        animation-duration: 0.1s;
        animation-direction: normal;
        animation-timing-function: ease;
        animation-iteration-count: infinite;
    }
    .tokenfield .token.invalid {
        background: none;
        border: 1px solid transparent;
        border-radius: 0;
        border-bottom: 1px dotted #d9534f;
    }
    .tokenfield .token.invalid.active {
        background: #ededed;
        border: 1px solid #ededed;
        border-radius: 3px;
    }
    .tokenfield .token .token-label {
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        padding-left: 4px;
        vertical-align: top;
    }
    .tokenfield .token .close {
        display: inline-block;
        font-size: 1.1em;
        line-height: 1.49em;
        margin-left: 5px;
        float: none;
        height: 100%;
        vertical-align: top;
        padding-right: 4px;
    }
    .tokenfield .token-input {
        background: none;
        min-width: 60px;
        border: 0;
        height: 20px;
        padding: 0;
        margin-bottom: 6px;
        box-shadow: none;
        width: 100% !important;
    }
    .tokenfield .token-input:focus {
        border-color: transparent;
        outline: 0;
        box-shadow: none;
    }
    .tokenfield.disabled {
        cursor: not-allowed;
        background-color: #eeeeee;
    }
    .tokenfield.disabled .token-input {
        cursor: not-allowed;
    }
    .tokenfield.disabled .token:hover {
        cursor: not-allowed;
        border-color: #d9d9d9;
    }
    .tokenfield.disabled .token:hover .close {
        cursor: not-allowed;
    }
    .has-warning .tokenfield.focus {
        border-color: #66512c;
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #c0a16b;
    }
    .has-error .tokenfield.focus {
        border-color: #843534;
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ce8483;
    }
    .has-success .tokenfield.focus {
        border-color: #2b542c;
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #67b168;
    }
    .tokenfield.input-sm,
    .input-group-sm .tokenfield {
        min-height: 30px;
        padding-bottom: 0;
    }
    .input-group-sm .token,
    .tokenfield.input-sm .token {
        height: 20px;
        margin-bottom: 4px;
    }
    .input-group-sm .token-input,
    .tokenfield.input-sm .token-input {
        height: 18px;
        margin-bottom: 5px;
    }
    .tokenfield.input-lg,
    .input-group-lg .tokenfield {
        height: auto;
        min-height: 45px;
        padding-bottom: 4px;
    }
    .input-group-lg .token,
    .tokenfield.input-lg .token {
        height: 25px;
    }
    .input-group-lg .token-label,
    .tokenfield.input-lg .token-label {
        line-height: 23px;
    }
    .input-group-lg .token .close,
    .tokenfield.input-lg .token .close {
        line-height: 1.3em;
    }
    .input-group-lg .token-input,
    .tokenfield.input-lg .token-input {
        height: 23px;
        line-height: 23px;
        margin-bottom: 6px;
        vertical-align: top;
    }
    .tokenfield.rtl {
        direction: rtl;
        text-align: right;
    }
    .tokenfield.rtl .token {
        margin: -1px 0 5px 5px;
    }
    .tokenfield.rtl .token .token-label {
        padding-left: 0;
        padding-right: 4px;
    }

    .tokenfield .twitter-typeahead {
        &:before {
            top: 2px;
        }
        .tt-input {
            padding-left: 27px;
        }
    }
`;
